var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFieldSearch = function SvgFieldSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.347 16.878q-3.496 0-5.922-2.452T0 8.439t2.425-5.987T8.347 0q3.495 0 5.921 2.452 2.425 2.452 2.425 5.987 0 1.478-.49 2.824a7.9 7.9 0 0 1-1.31 2.34l4.817 4.242q.283.286.29.72a.98.98 0 0 1-.29.734q-.297.3-.72.3a.97.97 0 0 1-.718-.3l-4.818-4.242a7.8 7.8 0 0 1-2.354 1.338 8 8 0 0 1-2.753.483m0-2.07q2.637 0 4.468-1.851t1.831-4.518-1.83-4.518-4.47-1.851q-2.637 0-4.468 1.85-1.83 1.852-1.831 4.519t1.831 4.518q1.83 1.851 4.469 1.851"
  })));
};
export default SvgFieldSearch;